// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".modal-container .modal-footer[data-v-7fb1c864] {\n  padding: var(--space-normal) var(--space-medium);\n}", "",{"version":3,"sources":["/home/danford/drochat/app/javascript/dashboard/components/widgets/modal/ConfirmationModal.vue"],"names":[],"mappings":"AACA;EACE,gDAAA;AAAF","file":"ConfirmationModal.vue","sourcesContent":["\n.modal-container .modal-footer {\n  padding: var(--space-normal) var(--space-medium);\n}\n"]}]);
// Exports
module.exports = exports;
